import { DocCategory } from "./enums";
import { Dayjs } from "dayjs";

export interface InitResponse {
    initResponse: {
        isAuthenticated: boolean;
        displayName: string;
        organizationLogoUrl: string;
        cultureName: string;
        cultureTwoLetter: string;
        appVersion: string;
        timeZone: string;
        isRtl: boolean;
        phoneNumber: string;
        isActive: boolean;
        imagePath: string;
        currencies: Currencies[];
        messages: MessageItem[];
        walletBalanceMessageFrequency: number;
        walletLoadingMinDays: number;
        walletLoadingPortionSize?: number;
        walletMaxLoadingAmount: number;
        permissions: UserPermissionStruct[];
        employeeImportFrequencyValid: boolean;
        walletSource: number;
        recaptchaSiteKey: string;
    };
}

export interface Currencies {
    id: number;
    name: string;
    culture: string;
    symbol: string;
}

export class EmployeeGroup {
    id: number;
    text: string;
    constructor() {
        this.id = 0;
        this.text = "";
    }
}

export class OrganizationUnit {
    id: number;
    text: string;
    constructor() {
        this.id = 0;
        this.text = "";
    }
}

export class Region {
    id: string;
    text: string;
    constructor() {
        this.id = "";
        this.text = "";
    }
}

export class AttachedDoc {
    id = 0;
    createdAt = "";
    attachedBy = "";
    category: DocCategory | null = null;
    name = "";
    documentName = "";
    isActive = false;
}

export class AddDocRequest {
    employeeId = 0;
    document: File | null = null;
    name = "";
    documentName = "";
    category: DocCategory | null = null;
    isActive = true;
}

export class EditDocRequest {
    id = 0;
    name = "";
    documentName = "";
    category: DocCategory | null = null;
    isActive = true;
}

export class EmployeeDocsFilterRequest {
    keywords = "";
    fromDate: string | null = "";
    tillDate: string | null = "";
    docStatus = "";
    category: DocCategory | null = null;
    employeeId = 0;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex = 0;
}

export interface EmployeeDocsFilterResponse {
    hasNext: boolean;
    rows: AttachedDoc[];
    total: number;
    totalFilter: number;
}

export interface EmployeePageDataResponse {
    organizationUnits: OrganizationUnit[];
    employeeGroups: EmployeeGroup[];
}

export class IdText {
    id: string = "";
    text: string = "";
    constructor(id: string, text: string) {
        this.id = id;
        this.text = text;
    }
}

export class UserPermissionStruct {
    permissionName: PermissionName | null = null;
    permissionType: PermissionType | null = null;
}

export enum PermissionName {
    OrganizationDashboard = 1,
    ListOfEmployees = 2,
    CreateEmployee = 3,
    EditEmployee = 4,
    ImportEmployees = 5,
    EmployeeGeneralInfo = 6,
    EmployeeDigitalWallet = 7,
    EmployeeOrders = 8,
    EmployeeAttachedDocs = 9,
    AddAttachedDoc = 10,
    EditAttachedDoc = 11,
    ListOfWallets = 12,
    WalletBulkUpdate = 13,
    WalletTransaction = 14,
    WalletManagment = 15,
    ListOfOrders = 16,
    ListOfDocuments = 17,
    ListOfMessages = 18,
    CreateEditMessage = 19,
    ListOfForms = 20,
    CreateForms = 21,
    ManageUsers = 22,
    ManageProfiles = 23,
    InterfaceManagement = 24,
    ListOfTransactions = 25,
    LoadingNegativeWalletAmount = 26,
}

export enum PermissionType {
    View = 1,
    Edit = 2,
}

export class MessagesFilterRequest {
    pageIndex = 0;
    orderBy: string = "";
    orderAsc = false;
    keywords = "";
    providerName = "";
    fromDate: Dayjs | null = null;
    toDate: Dayjs | null = null;
    messageStatus?: boolean | null = null;
}

export class MessageItem {
    id = 0;
    title = "";
    content = "";
    active = true;
    createdAt = "";
    validDateFrom: string | null = "";
    validDateTo: string | null = null;
    sourceType = "";
    sourceId = 0;
    targetType = "";
    targetId = 0;
    read: boolean = false;
}

export interface MessagesFilterResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    messages: MessageItem[];
}

export class LoginRequest {
    username = "";
    captchaResponse = "";
}

export class LoginResponse {
    userHash = "";
}

export class LoginByCodeRequest {
    code = "";
    userHash = "";
    captchaResponse = "";
}

export class ForgotPasswordRequest {
    username = "";
    captchaResponse = "";
    constructor(username: string, captchaResponse: string) {
        this.username = username;
        this.captchaResponse = captchaResponse;
    }
}
export interface MarkMessageAsReadResponse {
    id: number;
}
